<template>
  <div>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.replyTo"
        :validator="vs.form.replyTo"
        :label="adminText('workflowsAll.reply_to_e_mail_a8e268a', 'Reply-to e-mail')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <select-field
        v-model="form.subscriptionPlan"
        :validator="vs.form.subscriptionPlan"
        :items="workflowUi(allSubscriptionPlans)"
        item-select="id"
        item-render="displayName"
        :label="adminText('workflowsAll.subscription_plans_e72b057', 'Subscription plans*')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <v-autocomplete
        v-model="form.eventId"
        :items="allOrganizationEvents"
        :label="adminText('workflowsAll.event_ad8919a', 'Event')"
        :item-text="event => event.title + ' - ' + workflowDate(event.from, 'DD.MM.yyyy [at] HH:mm')"
        item-value="id"
        box
        clearable
        @change="$emit('shortCodeHandle')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <select-field
        v-model="form.recipients"
        :validator="vs.form.recipients"
        :items="localizedRecipients"
        item-render="caption"
        item-select="value"
        :label="adminText('workflowsAll.recipients_faf993d', 'Recipients*')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <autocomplete-field
        v-if="form.recipients === 'Specific subscribers'"
        v-model="form.attendees"
        :items="workflowUi(subscribers)"
        item-select="id"
        item-render="name"
        :label="adminText('workflowsAll.subscribers_75ecd90', 'Subscribers*')"
        chips
        multiple
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field v-model.trim="form.subject" :validator="vs.form.subject" :label="adminText('workflowsAll.subject_54fc0ac', 'Subject*')" />
    </v-flex>
    <v-flex class="pb-16">
      <text-editor-field
        v-model.trim="form.content"
        :validator="vs.form.content"
        :label="adminText('workflowsAll.content_4f9be05', 'Content')"
        height="390"
        style="margin: 0"
        :error-messages="{
          requiredShortCodes:
            adminText('workflowsAll.please_add_the_subscriber_s_name_and_email_so_c145896', 'Please add the subscriber’s name and email so the user knows which subscription the response is for.'),
        }"
      />
    </v-flex>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { GET_ORGANIZATION_PREPAID_COUPON_USERS } from '@/graphql/prepaidCouponUser.graphql'
import { uniqBy } from 'lodash'
import moment from 'moment'

export default {
  mixins: [WorkflowDisplay],
  name: 'create-sport-subscription-email-form',
  props: {
    vs: {
      type: Object,
      default: () => {},
    },
    organizationSlug: String,
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      allSubscriptionPlans: [],
      allSubscribers: [],
      textEditorRequiredMsg: false,
      allOrganizationEvents: [],
      subscribers: [],
      recipients: ['All subscribers', 'Specific subscribers'],
    }
  },
  computed: {
    localizedRecipients() {
      return this.recipients.map(value => ({ value, caption: this.workflowRecipientOption(value) }))
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
    'form.subscriptionPlan': {
      handler(val) {
        this.subscribers = this.allSubscribers.filter(
          subscriber => subscriber.prepaidCoupon.id === val,
        )
        this.form.attendees = this.form.recipients === 'All subscribers' ? this.subscribers : []
      },
    },
    'form.recipients': {
      handler(val) {
        if (val === 'Specific subscribers') return

        if (!this.form.subscriptionPlan) {
          this.form.attendees = this.allSubscribers

          return
        }

        this.form.attendees = this.allSubscribers.filter(
          subscriber => subscriber.prepaidCoupon.id === this.form.subscriptionPlan,
        )
      },
    },
  },
  apollo: {
    getOrganizationPrepaidCouponUsers: {
      query: GET_ORGANIZATION_PREPAID_COUPON_USERS,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const {
            getOrganizationPrepaidCouponUsers: prepaidCouponUsers,
            getFutureOrganizationEvents: events,
          } = data
          this.allOrganizationEvents = events.map(e => {
            return { ...e, name: `${e.title} - ${moment(e.from).format('DD.MM.yyyy [at] HH:mm')}` }
          })
          this.allSubscribers = this.filterSubscribersWithEmail(prepaidCouponUsers)
          this.subscribers = this.allSubscribers
          this.allSubscriptionPlans = uniqBy(
            this.allSubscribers.flatMap(prepaidCouponUser => prepaidCouponUser.prepaidCoupon),
            'id',
          ).map(plan => ({
            ...plan,
            displayName: plan.season ? `${plan.name}, ${plan.season}` : plan.name,
          }))
        }
      },
    },
  },
  methods: {
    filterSubscribersWithEmail(prepaidCouponUsers) {
      return prepaidCouponUsers.filter(
        prepaidCouponUser => !!prepaidCouponUser.fields['Email'] || !!prepaidCouponUser.email,
      )
    },
  },
}
</script>

<style scoped></style>
